import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export function LegalPage({ overline, title, updated, children, testid }) {
  return (
    <div className="min-h-screen bg-background" data-testid={testid}>
      <Navbar />
      <div className="bg-primary">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14">
          {overline && <p className="overline text-accent mb-3">{overline}</p>}
          <h1 className="font-display font-bold text-white text-3xl sm:text-4xl tracking-tight">{title}</h1>
          {updated && <p className="text-white/60 text-sm mt-3">Last updated: {updated}</p>}
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-12">
        <div className="space-y-8">{children}</div>
      </div>
      <Footer />
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section>
      {heading && <h2 className="font-display font-semibold text-xl text-primary mb-3">{heading}</h2>}
      <div className="text-muted-foreground leading-relaxed space-y-3 text-sm sm:text-base">{children}</div>
    </section>
  );
}
